import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

// Extracts the language segment from a pathname like "/it/privacy" -> "it"
function getLang(pathname) {
  const parts = pathname.split("/").filter(Boolean);
  return parts[0] || "";
}

// Extracts the rest of the path after the language segment
function getPathAfterLang(pathname) {
  const parts = pathname.split("/").filter(Boolean);
  return "/" + parts.slice(1).join("/");
}

export default function ScrollToTop() {
  const { pathname } = useLocation();
  const prev = useRef(pathname);

  useEffect(() => {
    const prevLang = getLang(prev.current);
    const currLang = getLang(pathname);
    const prevRest = getPathAfterLang(prev.current);
    const currRest = getPathAfterLang(pathname);

    // Language switch: same "rest of path", different language -> DO NOT scroll
    const isLanguageSwitchOnly =
      prevLang &&
      currLang &&
      prevLang !== currLang &&
      prevRest === currRest;

    if (!isLanguageSwitchOnly) {
      window.scrollTo({ top: 0, left: 0, behavior: "auto" });
    }
    prev.current = pathname;
  }, [pathname]);

  return null;
}
